export default __webpack_public_path__ + "static/media/menu.4014346b.svg";